import Vue from "vue";
import App from "@/App.vue";
import routes from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/locales/i18n";
import VueRouter from "vue-router";

import CustomHelpPage from "@app/views/Help.vue";

export default function Init() {
  if (routes && routes[0].children)
    routes[0].children[2] = {
      path: "/help",
      component: CustomHelpPage
    };
  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
  });

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    // provide: {
    //   $rules: rules,
    //   company: process.env.VUE_APP_CONFIGS_NAME
    // },
    render: h => h(App)
  }).$mount("#app");
}
